import { useAuth } from "domain/auth/authContext";
import useSWR from "swr";

export default function useDataTimeline(
  /**
   * provide initialData to skip revalidation on mount
   */
  initialData?: any,
) {
  const { service } = useAuth();

  return useSWR<ResCaseTimeline>(`/timeline`, () => service.getTimeline(), {
    fallbackData: initialData,
    shouldRetryOnError: false,
  });
}
